import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Spinner } from '../components/ui/spinner.tsx';
import { Button } from '../components/ui/button.tsx';
import rehypeRaw from "rehype-raw";

const UserGuidePage: React.FC = () => {
  const [markdown, setMarkdown] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const handleGuideClick = (evt) => {
    if(evt.target.getAttribute('data-clickable')) {
      if(evt.target.style.height!='740px') {
        evt.target.style.height='740px';
        evt.target.style.width='500px';
      } else {
        evt.target.style.height='260px';
        evt.target.style.width='180px';
      }
    }
  };

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        const response = await fetch('/readme.md'); // Assuming readme.md is in the public folder
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const text = await response.text();

        setMarkdown(text);
      } catch (e: any) {
        setError(e.message || 'Failed to load user guide.');
      } finally {
        setLoading(false);
      }
    };

    fetchMarkdown();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner size="lg" />
        <p className="ml-2 text-muted-foreground">Loading user guide...</p>
      </div>
    );
  }

  return (
    <div className="prose dark:prose-invert max-w-none p-4" onClick={handleGuideClick}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{markdown}</ReactMarkdown>
    </div>
  );
};

export default UserGuidePage;
